export default __webpack_public_path__ + "static/media/1.10750d1e.jpg";